import React from "react";
import { StarIcon, FileTextIcon, ZapIcon, ChefHatIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { TrustRow } from "./TrustRow";
const MOCKUP = "https://cdn.magicpatterns.com/uploads/uGM9xBJxjKhN3Y91ovNmFJ/Mockup_shopify.png";
export function Hero() {
  return <header id="inicio" className="bg-cream" data-id="element-139" data-mp="4m8msdv40tlg">
      <div className="mx-auto grid max-w-6xl gap-6 px-5 pb-10 pt-6 md:px-8 lg:grid-cols-[1.05fr_1fr] lg:grid-rows-[auto_1fr] lg:gap-x-16 lg:gap-y-8 lg:pb-24 lg:pt-16" data-id="element-140" data-mp="4njqyesgw3d3">
        <div data-id="element-141" data-mp="xbfkxbqnjh66">
          <p className="font-display text-lg italic leading-snug text-wine md:text-2xl" data-id="element-142" data-mp="xbpbp1jitscx">
            Todo tu último trimestre del año resuelto en la cocina
          </p>
          <h1 className="mt-2 font-display text-[40px] leading-[1.02] text-forest md:mt-4 md:text-7xl" data-id="element-143" data-mp="ncq29gqxlsov">
            Megapack de <span className="text-wine" data-id="element-144" data-mp="3d2l95b1th306">Recetas Festivas</span>
          </h1>
          <div className="mt-4 flex items-center gap-4 md:mt-7 md:gap-5" data-id="element-145" data-mp="381xn73sg3cct">
            <div className="flex items-baseline font-display leading-none text-gold" data-id="element-146" data-mp="384s2yi0ik8zw">
              <span className="text-5xl md:text-6xl" data-id="element-147" data-mp="3j6fw9kdl53b7">6</span>
              <span className="mx-1 text-3xl md:text-4xl" data-id="element-148" data-mp="3o6kd5bieo01y">+</span>
              <span className="text-5xl md:text-6xl" data-id="element-149" data-mp="39al8ybyf2k23">3</span>
            </div>
            <div className="border-l border-line pl-4 text-xs font-semibold uppercase tracking-[0.14em] text-forest md:pl-5 md:text-sm" data-id="element-150" data-mp="39cpawocr98zq">
              Tomos
              <br data-id="element-151" data-mp="30h9d5w8vq9ov" />+ Bonos
            </div>
          </div>
        </div>
        <div className="lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-152" data-mp="3599k48nda2uy">
          <img src={MOCKUP} alt="Megapack de Recetas Festivas: 6 tomos de Halloween, Navidad y Año Nuevo, 3 bonos y 2 libros premium" className="aspect-[4/3] w-full rounded-2xl object-cover object-[50%_58%] shadow-[0_30px_60px_-30px_rgba(30,38,31,0.45)] lg:aspect-auto" data-id="element-153" data-mp="2qk3muq83ampp" />
        </div>
        <div data-id="element-154" data-mp="2ljpc30f3synz">
          <p className="max-w-xl text-base leading-relaxed text-ink/80 md:text-lg" data-id="element-155" data-mp="2lk8v6kghpt3l">
            Tus recetas completas para Halloween, Navidad y Año Nuevo listas: entradas, platos principales, postres,
            mesa dulce y tragos festivos. <strong className="font-semibold text-ink" data-id="element-156" data-mp="n9i2d87l96s0">Sin improvisar nunca más.</strong>
          </p>
          <ul className="mt-4 flex flex-wrap gap-1.5 text-xs font-medium text-forest md:mt-6 md:gap-2 md:text-[13px]" data-id="element-157" data-mp="i9vu7d6magq2">
            {[{
            icon: FileTextIcon,
            label: "PDF Digital"
          }, {
            icon: ZapIcon,
            label: "Acceso Inmediato"
          }, {
            icon: ChefHatIcon,
            label: "Principiante - Intermedio"
          }].map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-1.5 rounded-full bg-paper px-2.5 py-1 ring-1 ring-line md:px-3 md:py-1.5" data-id="element-158" data-mp="110wq1scfxw5e">
                <Icon className="h-3.5 w-3.5 text-gold" aria-hidden data-id="element-159" data-mp="3lsp3vew9yley" />
                {label}
              </li>)}
          </ul>
          <div className="mt-5 flex flex-col gap-3 md:mt-8 md:gap-4 sm:items-start" data-id="element-160" data-mp="3hqkc6lpdzyuy">
            <CTAButton data-id="element-161" data-mp="1xacdyyq6tbr4">Quiero mis recetas festivas ahora</CTAButton>
            <TrustRow variant="hero" data-id="element-162" data-mp="21amwfav61umv" />
          </div>
          <dl className="mt-6 grid grid-cols-3 border-t border-line pt-4 md:mt-10 md:max-w-md md:pt-6" data-id="element-163" data-mp="21bfy3xf9pty5">
            <div data-id="element-164" data-mp="268ognz4bvzzx">
              <dt className="sr-only" data-id="element-165" data-mp="26868c44e5vbn">Compradoras</dt>
              <dd className="font-display text-2xl text-forest md:text-3xl" data-id="element-166" data-mp="2b1r7w0lmuxcy">+500</dd>
              <dd className="text-xs text-muted" data-id="element-167" data-mp="2g0lpx0bs0hw0">Compradoras</dd>
            </div>
            <div data-id="element-168" data-mp="2kynd9xg8j3da">
              <dt className="sr-only" data-id="element-169" data-mp="2ky40ev5fz564">Rating</dt>
              <dd className="flex items-center gap-1 font-display text-2xl text-forest md:text-3xl" data-id="element-170" data-mp="2l0zyqkl7bvv3">
                4.9 <StarIcon className="h-4 w-4 fill-gold text-gold md:h-5 md:w-5" aria-hidden data-id="element-171" data-mp="2oyo128p84qx0" />
              </dd>
              <dd className="text-xs text-muted" data-id="element-172" data-mp="umhfcfyperqg">Rating</dd>
            </div>
            <div data-id="element-173" data-mp="uokepqlqxx7u">
              <dt className="sr-only" data-id="element-174" data-mp="zlkl62mid1zh">Alcance</dt>
              <dd className="font-display text-2xl text-forest md:text-3xl" data-id="element-175" data-mp="zmc4adyx578v">AR</dd>
              <dd className="text-xs text-muted" data-id="element-176" data-mp="4aclrbd6jn6w">Todo Argentina</dd>
            </div>
          </dl>
        </div>
      </div>
    </header>;
}